import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import ProductsLanding from "../views/ProductsLanding";
import Lgs from "../ones/Lgs";
import WaterProofing from "../ones/WaterProofing";
import Terrazzo from "../ones/Terrazzo";
import Additional from "../ones/Additional";
import Footer from "../ones/Footer";
import { PRODUCT_MAP } from "../data/productsCatalog";
import { Helmet } from "react-helmet-async";

export default function Products(props) {
  const appContext = useContext(AppContext);

  const [view, setView] = useState(null);

  async function init() {
    //run initializations here
  }

  function getView() {
    if (
      !appContext.navSubItem &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <ProductsLanding />;
    } else if (
      appContext.navSubItem === "light-gauge-steel" &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return (
        <>
          <Lgs />
          <Footer />
        </>
      );
    } else if (
      appContext.navSubItem === "waterproofing-solutions" &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return (
        <>
          <WaterProofing />
          <Footer />
        </>
      );
    } else if (
      appContext.navSubItem === "terrazzo-flooring" &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return (
        <>
          <Terrazzo />
          <Footer />
        </>
      );
    } else if (
      appContext.navSubItem === "additional-services" &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return (
        <>
          <Additional />
          <Footer />
        </>
      );
    }

    return <ProductsLanding />;
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    const _view = getView();
    if (_view) {
      setView(_view);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  //return desired view
  return (
    <>
      <Helmet>
        <title>Products | Group V Limited</title>
        <meta
          name="description"
          content="Explore our range of construction products and services in Tanzania."
        />
        <meta property="og:title" content="Products | Group V Limited" />
        <meta
          property="og:description"
          content="Explore our range of construction products and services in Tanzania."
        />
        <meta property="og:url" content="https://groupv.co.tz/#/products" />
      </Helmet>
      {view}
    </>
  );
}
